module.exports = __webpack_public_path__ + "img/e_2_20_r.d4e965d3.png";